import TextInput from "@/components/ui/TextInput"
import Page from "@/layouts/Page"

import LockIcon from "@mui/icons-material/Lock"
import Checkbox from "@mui/material/Checkbox"

import React from "react"
import { useState, useEffect } from "react"
import { useCheckPassword } from "@/hooks/useCheckPassword"
import { useAuthContext } from "@/hooks/useAuthContext"

//Component interface
interface AccessComponentProps {
   type: string
   children: React.ReactNode
   text?: string
}

//Products interfaces
interface AccessPasswordProps {
   setIsLoading: (status: boolean) => void
   setHasAccess: (status: boolean) => void
}

//Enum

enum AccessType {
   PASSWORD = "password"
}

//Concrete factory interface
const AccessComponent: React.FC<AccessComponentProps> = ({
   type,
   children,
   text
}): JSX.Element => {
   const [isLoading, setIsLoading] = useState(false)
   const [hasAccess, setHasAccess] = useState(false)

   return (
      <Page className="flex flex-col justify-center items-center py-12">
         {!hasAccess ? (
         <div className="bg-white flex flex-col gap-y-4">
            <p>{text}</p>
            <div className="flex flex-col justify-center items-center">
               {type === AccessType.PASSWORD ? (
                  <AccessGatedPage.Password
                     setIsLoading={setIsLoading}
                     setHasAccess={setHasAccess}
                  />
               ) : (
                  <p className="text-red-500">Tipo de acceso no soportado</p>
               )}
            </div>
            {!isLoading ? (
               <p className="text-red-500">Acceso denegado</p>
            ) : hasAccess ? (
               <div className="border rounded-xl bg-blue py-1 px-4 text-white animate-pulse">
                  Cargando...
               </div>
            ) : null}
         </div>
         ) : (<>{children}</>)}
      </Page>
   )
}

const AccessPassword: React.FC<AccessPasswordProps> = ({ setIsLoading, setHasAccess }) : JSX.Element => {
   const {user} = useAuthContext()
   const [password, setPassword] = useState('')
   const [passwordVisible, setPasswordVisible] = useState(false)
   const { status, error, checkPasswordFunction } = useCheckPassword()

   const handleVerify = () => {
      setIsLoading(true)
      checkPasswordFunction(user.email,password)
   }

   useEffect(()=>{
      setHasAccess(status)
   },[status])

   return (
      <div className ="flex flex-col gap-y-4">
         <TextInput
            icon={<LockIcon />}
            placeholder="Contraseña"
            type={passwordVisible ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
         />
         <div className="flex items-center">
            <Checkbox
               checked={passwordVisible}
               onChange={() => setPasswordVisible(!passwordVisible)}
               color="secondary"
            />
            <p>Mostrar contraseña</p>
         </div>
         <button
            onClick={handleVerify}
            className="border rounded-xl bg-blue-500 hover:bg-blue-700 py-1 px-4 text-white"
         >
            Verificar
         </button>
         {error && <p className="text-red-500">{error}</p>}
         {status && <p className="text-green-500">Acceso concedido</p>}
      </div>
   )
}

//Factory method
export const AccessGatedPage = Object.assign(AccessComponent, {
   Password: AccessPassword,
})

export default AccessGatedPage
